/**
 * このゲームの唯一の識別子。
 *
 * **Phaser を引かない軽いモジュールにしておくこと**。
 * `src/games/registry.ts` から**静的に** import されるので、ここが重いと
 * 初期バンドルにゲーム本体が載ってしまう（遅延読込の意味が消える）。
 *
 * この文字列は5か所で同じでなければならない:
 *   D1 の `game_key` / `src/games/2048/` / `src/locales/<lang>/2048.json` /
 *   `public/assets/2048/` / localStorage の `2048.*`
 * サーバー側の制約は `GAME_KEY_RE = /^[a-z0-9_-]{1,32}$/` ＝ **数字始まりも通る**。
 *
 * 💡 名前について: 「2048」は**記述的な一般名**で、オリジナル（Gabriele Cirulli）も
 *    MIT で公開されている。他社の登録商標を避ける必要があるのは
 *    ピクロス / 数独 / オセロ / 倉庫番 の系統（docs/GAMES-ROADMAP.md の命名規則）。
 */
export const GAME_KEY = '2048';
